import { css } from '@emotion/css'
import { spacing, shorthandHelper } from '@offerzen/pinata-shame'

const styles = {
  card: css({
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    padding: shorthandHelper([spacing.extraLarge, spacing.large]),

    '& > img': {
      marginBottom: spacing.large,
      maxWidth: '100%',
    },
  }),

  button: css({
    marginTop: spacing.large,
  }),
}

export default styles
